<template>
  <div class="contain">
	  <!--顶部-->
		<head-comp></head-comp>
		<!-- banner-->
		<div class="banner" >
      <div v-html="bannerImg"></div>
    </div>
		<!-- 内容-->
		<div class="w12">
			<div class="l slidebar">
				<!-- 通知公告 后勤动态-->
				<div class="r columnwidth">
					<div class="panel note" v-for="(item,index) in asideList" :key="index">
					  	<div class="panel-heading" :class="item.name == '通知公告'? 'clF9':'clD9'"> 
							<h3 class="panel-title">
								<span class="glyphicon glyphicon-bell" aria-hidden="true" v-if="item.name == '通知公告'"></span>
								<span class="glyphicon glyphicon-bullhorn" aria-hidden="true" v-if="item.name == '后勤动态'"></span>
								{{item.name}}
								<a class="more" href="javascript:;" @click="junmpToList(item.id)">More</a>
							</h3>
					 	</div>  
					 	<div class="line" :class="item.name == '通知公告'? 'bgF9':'bgD9'"></div>
					  	<div class="panel-body">
							<ul>
							  	<li v-for="(list,index) in item.arts" :key="index">
									<a href="javascript:;" @click="jumpToArt(list)">
										<span class="el-icon-star-off"></span>
										{{list.name}}
									</a>
									<span>{{item.update_time}}</span>
								</li>							  
							 </ul>  
					  	</div>
					</div>
				</div>
				<!-- 常用电话-->
				<div class="r columnwidth">
					<div class="panel tel">
					  	<div class="panel-heading">
							<h3 class="panel-title">
								<span class="glyphicon glyphicon-phone-alt" aria-hidden="true"></span>
								{{tel.name}}
								<a class="more" href="javascript:;" @click="junmpToList(tel.id)">More</a>
							</h3>
					 	</div>
					 	<div class="line"></div>
					  	<div class="panel-body">
					  		<a class="tel-link" v-for="(item,index) in tel.arts"  :key="index" href="javascript:;"  @click="jumpToArt(item)">{{item.name}}</a>
					  	</div>
					</div>
				</div>
			</div>
			<!-- 右边内容区-->
			<div class="r main">
				<!-- 栏目公告 -->
				<div class="recruit-info" v-for="(item,index) in newsList" :key="index">
					<div class="panel panel-primary">
						<div class="panel-heading">
						<h3 class="panel-title">{{item.name}}
							<router-link :to="'/list/'+item.id" class="rMore">More</router-link>
						</h3>
						</div>
						<div class="panel-body">
						<ul>
							<li v-for="(list,index) in item.arts" :key="index">
							<a href="javascript:;" @click="jumpToArt(list)">
								<span class="lanpanel">.</span>{{list.name}}
							</a>
							<span>{{item.update_time.slice(0,10)}}</span>
							</li>
						</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	<!-- 提示框 -->
	<tip :tip="tip" v-show="tipShow"></tip>
  <!-- 预加载 -->
  <page-load v-if="loading"></page-load>
	<!-- 底部-->
  <foot-comp></foot-comp>
</div>
</template>
<script>
import { getArtCates, getArticles } from "../api/api";
import footComp from "../components/footComp";
import headComp from "../components/headComp";
import pageLoad from "../pageload/pageload";

export default {
  components: { footComp, headComp, pageLoad },
  data() {
    return {
      asideList: [], //侧边栏目列表(通知公告和后勤动态)
      tel: {}, //常用电话信息
      tip: "", //提示语
      tipShow: false, //提示框默认状态
      bannerImg: "", //banner背景图
      newsList: [], //新闻列表
      searchInfo: "",
      week: "",
      year: "",
      month: "",
      day: "",
      loading: true //预加载
    };
  },
  created() {
    this._getArtCates(); //获取栏目列表
  },
  methods: {
    //获取栏目列表
    _getArtCates() {
      let data = JSON.parse(sessionStorage.getItem("data"));
      this.loading = true;
      if (data == null) {
        let module = {
          sch_id: 1,
          topic_id: 6
        };
        getArtCates(module)
          .then(res => {
            if (res.status && res.data && res.data.length > 0) {
              sessionStorage.setItem("data", JSON.stringify(res.data));
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].odx > 4 && res.data[i].odx < 7) {
                  //左侧
                  this.asideList.push(res.data[i]);
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].id == 93) {
                  //常用电话
                  this.tel = res.data[i];
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].id == 178) {
                  //banner图
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].odx == 0) {
                  //teb循环
                  this.newsList.push(res.data[i]);
                  this._getArticles(res.data[i].id, res.data[i]);
                }
              }
            } else {
              this.loading = false;
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        for (let i = 0; i < data.length; i++) {
          if (data[i].odx > 4 && data[i].odx < 7) {
            //左侧
            this.asideList.push(data[i]);
            this._getArticles(data[i].id, data[i]);
          } else if (data[i].id == 93) {
            //常用电话
            this.tel = data[i];
            this._getArticles(data[i].id, data[i]);
          } else if (data[i].id == 178) {
            //banner图
            this._getArticles(data[i].id, data[i]);
          } else if (data[i].odx == 0) {
            //teb循环
            this.newsList.push(data[i]);
            this._getArticles(data[i].id, data[i]);
          }
        }
      }
    },
    //获取通知公告栏目下的列表
    _getArticles(id, arr) {
      let module = {
        sch_id: 1,
        cate_id: id
      };
      getArticles(module)
        .then(res => {
          this.loading = false;
          if (res.status && res.data && res.data.arts.length > 0) {
            if (res.data.odx > 4 && res.data.odx < 7) {
              //左侧
              this.$set(arr, "arts", res.data.arts);
            } else if (res.data.id == 93) {
              //常用电话
              this.$set(arr, "arts", res.data.arts);
            } else if (res.data.id == 178) {
              //bananer图
              this.bannerImg = res.data.arts[0].des;
            } else if (res.data.odx == 0) {
              //teb循环
              this.$set(arr, "arts", res.data.arts);
            }
          } else {
            this.tipCtr("暂无数据");
          }
        })
        .catch(err => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //跳转到列表页
    junmpToList(item) {
      this.$router.push({ path: "/list/" + item });
    },
    //跳转到文章页
    jumpToArt(item) {
      this.$router.push("/article/" + item.cate_id + "/" + item.id);
    },
    //跳转到搜索页
    jumpSearch(item) {
      if (item == "") {
        this.tipCtr("请输入关键字");
      } else {
        this.$router.push({ path: "/search/" + item });
        this.searchInfo = "";
      }
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    }
  }
};
</script>

<style scoped>
body {
  background: #efefef;
}
/*banner*/
.banner {
  width: 100%;
  min-width: 1200px;
  height: 250px;
  margin: 0 auto;
  overflow: hidden;
}
.banner >>> img {
  width: 100%;
  height: 230px;
}
.w12 {
  background: #fff;
}
/*左边菜单*/
.slidebar {
  width: 300px;
  background: #ecf2f4;
  border: 1px solid #ddd;
}
.columnwidth {
  width: 100%;
  overflow: hidden;
}
.columnwidth > .panel {
  height: 230px;
  overflow: hidden !important;
}
.columnwidth .panel-title span {
  font-size: 16px;
  top: 2px;
  margin-right: 5px;
}
.more {
  float: right;
  margin-top: 5px;
  color: #999 !important;
}
.more:hover {
  color: #d9534f !important;
}
.rMore {
  float: right;
  margin-top: 2px;
  color: #fff !important;
}
.rMore:hover {
  color: #fd1 !important;
}
.panel {
  margin: 0;
  border-radius: 0;
  background: transparent;
}
.panel-heading {
  border-radius: 0;
}
.panel-body {
  padding: 3px 15px;
}
.panel > .panel-body > ul li {
  height: 35px;
}
.panel > .panel-body > ul li a {
  color: #666;
  font-size: 14px;
  display: inline-block;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.columnwidth > .panel > .panel-body > ul li a {
  width: 50%;
}
.recruit-info ul > li a {
  width: 70%;
}
.panel > .panel-body > ul li:hover a {
  color: red;
}
.panel > .panel-body > ul li > span {
  color: #999;
  float: right;
  font-size: 12px;
  line-height: 35px;
}
.panel > .panel-body > ul li a > span {
  color: #666;
  font-size: 10px;
  margin-right: 5px;
  top: 1px;
}
.panel > .panel-body > ul li:hover a > span {
  color: red;
}
/*通知公告*/
.note {
  padding: 10px 10px 0;
}
.note .panel-heading {
  padding: 10px 0;
  border-bottom: 1px #ddd solid;
}
.note .line {
  width: 120px;
  height: 2px;
  margin-top: -2px;
}
.note .panel-body {
  padding: 0;
}
.clF9 {
  color: #ff9000;
}
.bgF9 {
  background: #ff9000;
}
.clD9 {
  color: #d9534f;
}
.bgD9 {
  background: #d9534f;
}
/*常用电话*/
.tel {
  padding: 10px 10px 0;
}
.tel .panel-heading {
  color: #d9534f;
  padding: 10px 0;
  border-bottom: 1px #ddd solid;
}
.tel .panel-body {
  padding: 0;
}
.tel .line {
  width: 120px;
  height: 2px;
  background: #d9534f;
  margin-top: -2px;
}
.tel-link {
  display: inline-block;
  padding: 5px 12px;
  color: #428bca;
  position: relative;
  font-size: 16px;
  width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tel-link:hover {
  color: #d9534f;
}

/*main*/
.main {
  width: 900px;
  padding: 20px;
}
.main-tit {
  overflow: hidden;
}
/*天气*/

.weither > ul:nth-child(2) {
  margin-left: 30px;
}
.weither > ul > li {
  float: left;
}
.weither > ul > li:nth-child(2) {
  margin: 0 10px;
}
.weither > ul:nth-child(2) > li > span:first-child {
  color: green;
}
.weither > ul:nth-child(2) > li > span:nth-child(2) {
  color: red;
  display: inline-block;
  margin-right: 5px;
}
.weither > ul:nth-child(2) > li:nth-child(3) > a {
  color: #000;
}

/* 图片新闻 */
.recruit-info {
  width: 49%;
  margin-bottom: 20px;
}
.recruit-info li:first-child {
  margin-top: 10px;
}
.recruit-info > .panel {
  height: 306px;
  overflow: hidden !important;
}
.main > div:nth-child(2n) {
  float: left;
}
.main > div:nth-child(2n-1) {
  float: right;
}
.lanpanel {
  font-size: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue